export default __webpack_public_path__ + "static/media/pop-del-icon.b2ae4a68.svg";